import { render, staticRenderFns } from "./RedesSociais.vue?vue&type=template&id=77b6d5aa&scoped=true"
import script from "./RedesSociais.vue?vue&type=script&lang=js"
export * from "./RedesSociais.vue?vue&type=script&lang=js"
import style0 from "./RedesSociais.vue?vue&type=style&index=0&id=77b6d5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6d5aa",
  null
  
)

export default component.exports